import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { Sparkles, LogOut, Shield, ChevronDown, Mail } from "lucide-react";

// Unveil logo. Logged-out: links home. Logged-in: opens a dropdown ON HOVER
// (Admin Dashboard if admin, + Logout). Click/keyboard still work too.
export const BrandMenu = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const closeTimer = useRef(null);

  const openNow = () => { if (closeTimer.current) { clearTimeout(closeTimer.current); closeTimer.current = null; } setOpen(true); };
  const closeSoon = () => { if (closeTimer.current) clearTimeout(closeTimer.current); closeTimer.current = setTimeout(() => setOpen(false), 150); };

  const Logo = ({ withChevron }) => (
    <span className="flex items-center gap-2 font-display font-black text-xl tracking-tight">
      <Sparkles className="w-5 h-5 text-gold" /> Unveil
      {withChevron && <ChevronDown className={`w-4 h-4 text-foreground/50 transition-transform ${open ? "rotate-180" : ""}`} />}
    </span>
  );

  if (!user) {
    return (
      <button data-testid="brand-logo" onClick={() => navigate("/")} className="cursor-pointer bg-transparent border-0 p-0">
        <Logo />
      </button>
    );
  }

  return (
    <DropdownMenu open={open} onOpenChange={setOpen} modal={false}>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="brand-menu-trigger"
          onMouseEnter={openNow}
          onMouseLeave={closeSoon}
          className="cursor-pointer bg-transparent border-0 p-0 outline-none focus:outline-none"
        >
          <Logo withChevron />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        sideOffset={8}
        onMouseEnter={openNow}
        onMouseLeave={closeSoon}
        onCloseAutoFocus={(e) => e.preventDefault()}
        className="glass border-white/10 w-52"
      >
        {user.role === "admin" && (
          <DropdownMenuItem data-testid="menu-admin-dashboard" onClick={() => navigate("/admin")} className="cursor-pointer">
            <Shield className="w-4 h-4 mr-2 text-gold" /> Admin Dashboard
          </DropdownMenuItem>
        )}
        {user.role === "admin" && <DropdownMenuSeparator className="bg-white/10" />}
        <DropdownMenuItem data-testid="menu-contact" onClick={() => navigate("/contact")} className="cursor-pointer">
          <Mail className="w-4 h-4 mr-2 text-gold" /> Contact
        </DropdownMenuItem>
        <DropdownMenuSeparator className="bg-white/10" />
        <DropdownMenuItem data-testid="menu-logout" onClick={() => { logout(); navigate("/"); }} className="cursor-pointer text-destructive focus:text-destructive">
          <LogOut className="w-4 h-4 mr-2" /> Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
